import styled from 'styled-components';

/**
 * Pill-shaped cluster sitting above the card's top-right corner. The
 * shell-side {@code FloatingActions} slot already controls
 * visibility — this component only owns the visual treatment of the
 * cluster (background, padding, gap) so the cluster reads as a single
 * floating chip rather than a row of disjoint buttons.
 *
 * Mirrors the design's `.ns-node__hover-actions` rule: small dark pill
 * with subtle drop shadow that lifts off the canvas without being
 * heavier than the card itself.
 */
export const FloatingCluster = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 4px;
  background: ${({ theme: { colors = {} } }) =>
    colors.surfaceContainerHigh ?? '#1F2030'};
  border: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#25263A'};
  border-radius: 999px;
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.32),
    0 1px 0 rgb(255 255 255 / 0.04) inset;
  color: ${({ theme: { colors = {} } }) =>
    colors.onSurfaceVariant ?? '#A1A3B8'};
`;
